import _findIndex from 'lodash.findindex';

export function findIndex<T = any, P = any>(collection: T[], predicate: P) {
  return _findIndex(collection, predicate);
}
